import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import { EXTRACT_TEXT_VIEW, MARKUP_VIEW } from "../../constants/Constants";
import { setShowOrientationModal } from "../../reducers/extractText-reducer";
import navigatorService from "../../services/navigatorService";
import zoomService from "../../services/zoomService";
import extractTextService from "../../services/extractTextService";
import CenterModal from "../UI/Modal/CenterModal";
import livePointerService from "../LivePointer/livePointerService";
import markupService from "../../services/MarkupService/markupService";
import arMarkupService from "../../services/MarkupService/arMarkupService";

const OrientationChangeModal = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { showOrientationModal, extractTextInprogress } = useSelector((state) => state.extractText);
    const { pointerOn } = useSelector((state) => state.livePointer);
    const { markupInprogress } = useSelector((state) => state.markup);

    const { startLocalVideo } = useSelector((state) => state.twilioEvents);

    const handleCloseModal = () => {
        dispatch(setShowOrientationModal(false));
    };

    useEffect(() => {
        const handleOrientationchange = () => {
            const deviceOrientation = navigatorService.getOrientation();
            // need to handle below code after code merged in dev
            if (pointerOn && deviceOrientation != livePointerService.lpOrientation) {
                dispatch(setShowOrientationModal(true));
            }

            if (extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW && deviceOrientation != extractTextService.OCROrientation) {
                //OCR is on and orientation is not same as when OCR started
                dispatch(setShowOrientationModal(true));
            }
            if (
                (markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW || arMarkupService.checkARMarkupIsOngoing()) &&
                deviceOrientation != markupService.markupOrientation
            ) {
                //Markup is on and orientation is not same as when Markup started
                dispatch(setShowOrientationModal(true));
            }
            zoomService.disablePinchZoom(); // disable pinch zoom
            setTimeout(() => {
                if (!startLocalVideo) {
                    // if local participant's video is ON
                    zoomService.resetPinchZoom(); // reset pinch zoom browser for local user
                }
            }, 1000);
        };
        if (navigatorService.isMobileDeviceOrIpadOs()) {
            window.addEventListener("orientationchange", handleOrientationchange);
        }

        return () => {
            window.removeEventListener("orientationchange", handleOrientationchange);
        };
    }, []);

    const modalHeader = (
        <>
            <h5 className='modal-title'>{localisedValues["message_title"]}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={handleCloseModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const modalBody = (
        <div className='cms-modal-text'>
            {extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW && <p>{localisedValues["do_not_rotate_the_phone_OCR_message"]}</p>}
            {(markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW || arMarkupService.checkARMarkupIsOngoing()) && (
                <p>{localisedValues["do_not_rotate_the_phone_markup_message"]}</p>
            )}
            {pointerOn && <p>{localisedValues["do_not_rotate_the_phone_live_pointer_message"]}</p>}
        </div>
    );

    const modalFooter = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' onClick={handleCloseModal}>
                    {localisedValues["got_it_btn"]}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={showOrientationModal}
            closeModal={handleCloseModal}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={modalHeader}
            body={modalBody}
            footer={modalFooter}
            backdrop={"static"}
        />
    );
};

export default OrientationChangeModal;
